var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error',{attrs:{"code":500,"text":'Ошибка сервера.'}})}
var staticRenderFns = []

export { render, staticRenderFns }